import React from 'react';
import PropTypes from 'prop-types';
import { VpMediaViewList } from '../VpMediaViewList';
import VpCollectedInfoBox from '../VpCollectedInfoBox/VpCollectedInfoBox';

export const VpMediaListBox = ({ mediaList, onClick, selectedMediaId, mediaLabels }) => {
  return (
    <>
      <VpCollectedInfoBox icon="Video" value="Media" amount={mediaList?.length || 0} />
      <VpMediaViewList
        mediaList={mediaList}
        onClick={onClick}
        selectedMediaId={selectedMediaId}
        mediaLabels={mediaLabels}
      />
    </>
  );
};

VpMediaListBox.propTypes = {
  mediaList: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
  selectedMediaId: PropTypes.string,
  mediaLabels: PropTypes.object.isRequired
};

export default VpMediaListBox;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpMediaListBox/VpMediaListBox.jsx